import { Api } from "./Api.class";
const endpoint = "works/list";
const worksListAPI = new Api(endpoint);
export default worksListAPI;
